"use client";

export default function TourFilterBar() {
  return null;
}